var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrommetIconsLanguage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6684_13171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99978 15.1109C11.9271 15.1109 15.1109 11.9271 15.1109 7.99978C15.1109 4.07251 11.9271 0.888672 7.99978 0.888672M7.99978 15.1109C4.07251 15.1109 0.888672 11.9271 0.888672 7.99978C0.888672 4.07251 4.07251 0.888672 7.99978 0.888672M7.99978 15.1109C9.93918 15.1109 10.5856 11.8786 10.5856 7.99978C10.5856 4.121 9.93918 0.888672 7.99978 0.888672M7.99978 15.1109C6.06039 15.1109 5.41392 11.8786 5.41392 7.99978C5.41392 4.121 6.06039 0.888672 7.99978 0.888672M1.53514 10.5856H14.4644M1.53514 5.41392H14.4644",
    stroke: "white",
    strokeWidth: 1.02564
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6684_13171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrommetIconsLanguage);
export default __webpack_public_path__ + "static/media/grommet-icons_language.4cb307cc0fdf143fe20a7a9786c1a361.svg";
export { ForwardRef as ReactComponent };